module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-MediumItalic-WebXL-d84375662567e2011110812bbfa49e68.woff2";